export default "__VITE_ASSET__LRz4YOXe__"